import {FC, useMemo, useRef, useState} from "react";
import {
    Checkbox, CheckboxProps,
    ClickAwayListener,
    FormControlLabel,
    Grow,
    MenuItem,
    MenuList,
    Paper,
    Popper
} from "@mui/material";
import {
    CheckboxBadge,
    CustomBadge,
    Divider,
    FilterIconButton,
} from "./filters-styles";
import {Icon} from '@iconify/react';
import {DEFAULT_FILTERS} from "../../../ducks/consts";
import {getDifferenceName} from "../../../selectors/other";
import {useSelector} from "react-redux";
import {selectDetailedDocuments, selectDiscrepancyFilters} from "../../../selectors/monitoring";
import {getStoreUtils} from "../../../store/utils";
import {setDiscrepancyFilters} from "../../../ducks/montitoring";

export const DiscrepancyFilters: FC = () => {
    const anchorComp = useRef(null);
    const [openFilterMenu, setOpenFilterMenu] = useState(false);
    const discrepancyFilterList = useSelector(selectDiscrepancyFilters);
    const {dispatch} = getStoreUtils();
    const detailedDocuments = useSelector(selectDetailedDocuments)
    const filteredDiscrepancy = useMemo(() => {
        if(detailedDocuments && detailedDocuments[0]) {
            const document = detailedDocuments[0];
            return document.docflowDocumentData.extendData.discrepancyData.map((elem) => (elem.type)).filter(function(item, i, ar){ return ar.indexOf(item) === i; }).filter(el => !discrepancyFilterList.includes(el))
        }
        return [];
    }, [detailedDocuments, discrepancyFilterList]);
    const handleFilterMenuClose = () => {
        if (openFilterMenu) {
            setOpenFilterMenu(() => false)
        }
    }

    const handleFilterMenu = () => {
        setOpenFilterMenu((prevValue) => !prevValue)
        if (!!openFilterMenu) {
        }
    }

    const updateDiscrepancyFilterList = (filters?: string[]) => {
        dispatch(setDiscrepancyFilters(filters))
    }

    const handleFiltersChange: (elem: string) => CheckboxProps['onChange'] = (elem) =>  (e) => {
        e.stopPropagation();

        if (discrepancyFilterList.includes(elem)) {
            updateDiscrepancyFilterList(discrepancyFilterList.filter(el => el !== elem));
        } else {
            updateDiscrepancyFilterList([...discrepancyFilterList, elem]);
        }

    }
    return <ClickAwayListener onClickAway={handleFilterMenuClose}>
        <FilterIconButton
            title={'Настройки сверки'}
            ref={anchorComp}
            size={"small"}
            isActive={openFilterMenu}
            onClick={handleFilterMenu}
            disableRipple
        >
            <CustomBadge isFilter variant="dot" invisible={filteredDiscrepancy.length === 0}>
                <Icon icon="gala:settings" width="28" color={`#000`} height="28"/>
            </CustomBadge>
            <Popper
                anchorEl={anchorComp ? anchorComp.current : null}
                open={openFilterMenu}
                transition
                disablePortal
                sx={{top: 80, zIndex: 1100 }}
                placement={'bottom-start'}
            >
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "center top" : "center bottom"
                        }}
                    >
                        <Paper
                        >
                            <MenuList
                                sx={{
                                    marginTop: `10px`,
                                    alignItems: 'start'
                                }}
                                id="menu-list-grow"
                            >
                                {DEFAULT_FILTERS.map((elem) => {
                                    const name = getDifferenceName(elem);
                                    return <MenuItem
                                        onClick={(e) => {
                                            e.stopPropagation();
                                        }}
                                        sx={{
                                            fontSize: '14px',
                                            paddingTop: '0px',
                                            paddingBottom: '0px',
                                        }}
                                    >
                                        <FormControlLabel
                                            sx={{
                                                fontSize: '14px'
                                            }}
                                            control={
                                                <CheckboxBadge
                                                    isFilter
                                                    variant="dot"
                                                    invisible={!filteredDiscrepancy.includes(elem)}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            height: '32px',
                                                            width: '32px',
                                                            color: `#F57B20`,
                                                            '&.Mui-checked': {
                                                                color: `#F57B20`,
                                                            },
                                                            fontSize: '14px',
                                                        }}
                                                        checked={discrepancyFilterList.includes(elem)}
                                                        defaultChecked
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                        onChange={handleFiltersChange(elem)}
                                                    />
                                                </CheckboxBadge>
                                            } label={<span
                                            style={{fontSize: '14px'}}>{`${name}`}</span>}/>
                                    </MenuItem>
                                })}
                                <Divider/>
                                <MenuItem
                                    sx={{
                                        fontSize: '14px',
                                        paddingTop: '0px',
                                        paddingBottom: '0px',
                                    }}
                                >
                                    <FormControlLabel
                                        sx={{
                                            fontSize: '14px'
                                        }}
                                        control={
                                            <Checkbox
                                                sx={{
                                                    height: '32px',
                                                    width: '32px',
                                                    color: `#F57B20`,
                                                    '&.Mui-checked': {
                                                        color: `#F57B20`,
                                                    },
                                                    fontSize: '14px',
                                                }}
                                                checked={discrepancyFilterList.length === (DEFAULT_FILTERS.length)}
                                                defaultChecked
                                                onChange={(event) => {
                                                    event.stopPropagation();
                                                    if (discrepancyFilterList.length === (DEFAULT_FILTERS.length)) {
                                                        updateDiscrepancyFilterList([]);
                                                    } else {
                                                        updateDiscrepancyFilterList([...DEFAULT_FILTERS]);
                                                    }
                                                }}
                                            />} label={<span
                                        style={{fontSize: '14px'}}>{`Включить/отключить все фильтры`}</span>}/>
                                </MenuItem>
                            </MenuList>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </FilterIconButton>
    </ClickAwayListener>
}
